import { render, staticRenderFns } from "./SolutionFTTx.vue?vue&type=template&id=21ae989c&scoped=true&"
import script from "./SolutionFTTx.vue?vue&type=script&lang=js&"
export * from "./SolutionFTTx.vue?vue&type=script&lang=js&"
import style0 from "./SolutionFTTx.vue?vue&type=style&index=0&id=21ae989c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ae989c",
  null
  
)

export default component.exports